import React, {useContext, useState} from 'react'
import {UserContext} from "./components/UserContext";
import ReactModal from "react-modal";
import Avatar from "@mui/material/Avatar";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import heic2any from "heic2any";
import axios from "axios";
import {getBearerToken, getServerUrl} from "./components/utils/utils";

function EditUserModal({isOpen, onClose}) {
    const {user, updateUser} = useContext(UserContext)
    const [username, setUsername] = useState(user?.displayName)

    const saveUser = async () => {
        axios.put(`${getServerUrl()}/user/${user?.id}`, {
            username: username,
        }, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
                "Access-Control-Allow-Headers": "Content-Type, Authorization, X-Requested-With",
                Authorization: `Bearer ${await getBearerToken()}`
            },
        }).then(response => {
            const updatedUser = {...user}
            updatedUser.displayName = response.data.username
            updateUser(updatedUser)
            onClose()
        });
    }

    const submitImage = async (reader) => {
        const userWithNewProfilePicture = { ...user}
        userWithNewProfilePicture.profilePictureUrl = reader.result
        updateUser(userWithNewProfilePicture)
        axios.post(`${getServerUrl()}/images/profilePicture`, {
            fileType: reader.result.split(";")[0].replace("data:", ""),
            image: reader.result.split(",")[1],
        }, {
            headers: {
                Authorization: `Bearer ${await getBearerToken()}`
            }
        })
            .then(res => {
                const updatedUser = { ...userWithNewProfilePicture}
                updatedUser.profilePictureId = res.data?.id
                updateUser(updatedUser)
            })
    }

    const addNewProfilePicture = async e => {
        const files = Object.values(e.target.files)
        const newFiles = await Promise.all(files.map(async file => {
            let updatedFile = file
            if (file.type.includes("heic")) {
                let blob = file //ev.target.files[0];
                await heic2any({
                    blob: blob,
                    toType: "image/jpg",
                })
                    .then(function (resultBlob) {
                        updatedFile = new File([resultBlob], "heic" + ".jpg", {
                            type: "image/jpeg",
                            lastModified: new Date().getTime()
                        });
                        return updatedFile
                    })
                    .catch(function (x) {
                        console.log(x.code);
                        console.log(x.message);
                    });
            }
            return updatedFile;
        }))
        const reader = new FileReader();
        reader.onloadend = function () {
            submitImage(reader, newFiles)
        }
        await reader.readAsDataURL(newFiles[0])
        e.target.value = null
    }

    return (
        <ReactModal isOpen={isOpen} className="edit-user-modal-parent">
            <div className="edit-user-modal-container">
                <div className="edit-user-modal">
                    <div className="user-avatar">
                        <Avatar sx={{width: 200, height: 200}} src={user?.profilePictureUrl}/>
                        <input
                            type="file"
                            id="edit-user-file-upload"
                            onChange={addNewProfilePicture}
                            style={{display: "none"}}
                            accept=".jpeg,.jpg,.png"
                        />
                        <button className="edit-profile" onClick={() => {
                            const hiddenFileInput = document.getElementById("edit-user-file-upload")
                            hiddenFileInput.click()
                        }}>Change</button>
                    </div>
                    <div>
                        <TextField
                            onChange={(event) => {
                                setUsername(event.target.value)
                            }}
                            value={username}

                        />
                    </div>
                    <div className="save-ranking-list-button">
                        <Button variant="contained" onClick={() => {
                            saveUser()
                        }
                        }>Save</Button>
                    </div>
                    <div className="close-button">
                        <CancelPresentationIcon sx={{fontSize: 40}} onClick={() => {
                            onClose()
                        }}/>
                    </div>
                </div>
            </div>
        </ReactModal>
    )
}

export default EditUserModal;